module.exports = __webpack_public_path__ + "img/banner-principal.3bd4fbca.png";